import React from 'react';
export function FooterSection() {
  return <footer className="bg-black text-gray-400 py-8 px-4 text-center text-sm" data-id="element-86">
      <div className="max-w-4xl mx-auto" data-id="element-87">
        <p className="mb-4" data-id="element-88">
          © 2026 MEGA KIT LECTOESCRITURA. Todos los derechos reservados.
        </p>
        <div className="flex justify-center gap-4" data-id="element-89">
          <a href="#" className="hover:text-white transition-colors" data-id="element-90">
            Privacidad
          </a>
          <span data-id="element-91">·</span>
          <a href="#" className="hover:text-white transition-colors" data-id="element-92">
            Términos y Condiciones
          </a>
        </div>
      </div>
    </footer>;
}